import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GlobalQuestionService} from 'src/app/modules/shared/services/global-question.service';
import {QuotePageDataVaps} from '../../../shared/models/quote.model';
import {VapParentQuestion} from '../../../shared/models/vap-parent-question';
import {MiniFlowSavedItems} from '../../../shared/models/mini-flow-saved-items';
import {VapService} from '../../../shared/services/vap.service';

declare const $: any;

@Component({
    selector: 'app-addon-modal',
    templateUrl: './addon-modal.component.html',
    styleUrls: ['./addon-modal.component.scss'],
    standalone: false
})
export class AddonModalComponent implements OnInit {

  @Input() renewal: boolean = false;
  @Output() benefitAdded = new EventEmitter();

  vap: QuotePageDataVaps;
  vapQuestion: VapParentQuestion;
  product_id: number;
  savedVaps: MiniFlowSavedItems[] = [];
  total = 0;
  isEdit = false;
  isAddAnother = false;

  constructor(
    public globalQuestionService: GlobalQuestionService,
    private vapService: VapService
  ) { }

  ngOnInit(): void {
  }

  showModal(vap: QuotePageDataVaps, question: VapParentQuestion, product_id: number, isEdit = false, isAddAnother = false): void {
    this.vap = null;
    this.vapQuestion = null;
    this.isEdit = false;
    this.isAddAnother = false;
    this.product_id = null;

    this.vap = vap;
    this.vapQuestion = question;
    this.product_id = product_id;
    this.isEdit = isEdit;
    this.isAddAnother = isAddAnother;
    console.log(this.vap, this.vapQuestion, this.product_id, this.isEdit, this.isAddAnother);
    $('#addons-modal').modal('show');
  }

  onItemsChanged(items: MiniFlowSavedItems[]): void {
    if (items?.length) {
      this.savedVaps = [];
      this.savedVaps = items;
      this.total = 0;
      for (const item of items) {
        this.total += item?.premium;
      }
    } else {
      this.total = 0;
    }
  }

  addAllAddons(): void {
    if (this.savedVaps?.length) {
      let thisItem: any;
      this.globalQuestionService.spinner(true);
      for (const item of this.savedVaps) {
        thisItem = item;
        this.vapService.addBenefits(this.vap?.class_id, this.vap?.product_vaps_id, item?.item_id, this.vapQuestion?.child_flow_id)
          .subscribe({
            next : () => {
              // this.benefitAdded.emit(this.savedVaps);
              // this.globalQuestionService.resetVaps(true);
            }
           
          });
      }
      setTimeout(() => {
        this.benefitAdded.emit({item: thisItem,vap: this.vap});
        this.globalQuestionService.resetVaps(true);
      }, 1000);
    }
  }

  removeBenefits(): void {
    if (!this.isAddAnother && this.savedVaps?.length) {
      for (const item of this.savedVaps) {
        this.vapService.removeBenefit(this.vap?.class_id, this.vap?.product_vaps_id, item?.item_id)
          .subscribe();
      }
    }
    $('#addons-modal').modal('hide');
  }

  closeAddon(): void {
    this.globalQuestionService.resetVaps(true);
  }

}
